(() => {
  const bodyClass = document.body.className || '';
  if (/\b(product|collection|list-collections)\b/.test(bodyClass)) return;
  if (document.querySelector('.zoda-split-dots, [data-zoda-split-dots]')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const main = document.querySelector('main#root, main[role="main"], main');
  if (!main || main.dataset.zodaPageSnapReady === 'true') return;

  const currentPath = String(window.location.pathname || '/').replace(/\/+$/, '') || '/';
  const hasHomePage = (currentPath === '/' || currentPath === '/pages/home') &&
    Boolean(main.querySelector('.shopify-section--zoda-snap-panel, [data-zoda-circuit].zoda-circuit--split'));
  const hasFabricsPage = Boolean(main.querySelector('[data-zoda-page-section^="fabrics-"], .zoda-fabrics-page:not(.zoda-ikigai-page):not(.zoda-mission-page)'));
  const hasIkigaiPage = Boolean(main.querySelector('[data-zoda-page-section^="ikigai-"], .zoda-ikigai-page'));
  const hasMissionPage = Boolean(main.querySelector('[data-zoda-page-section^="mission-"], .zoda-mission-page'));
  const hasAmbassadorsPage = Boolean(main.querySelector('[data-zoda-ambassadors]'));
  const hasAmbassadorRegistrationPage = Boolean(main.querySelector('[data-zoda-ambassador-registration]'));
  const isFabricsPage = !hasHomePage && (document.body.classList.contains('page-fabrics') || hasFabricsPage);
  const isIkigaiPage = !hasHomePage && (document.body.classList.contains('page-ikigai') || hasIkigaiPage);
  const isMissionPage = !hasHomePage && (document.body.classList.contains('page-mission') || hasMissionPage);
  const isAmbassadorRegistrationPage = !hasHomePage && (document.body.classList.contains('page-ambassador-registration') || hasAmbassadorRegistrationPage);
  const isAmbassadorsPage = !hasHomePage && !isAmbassadorRegistrationPage && (document.body.classList.contains('page-meet-the-ambassadors') || hasAmbassadorsPage);
  const isHomePage = hasHomePage;
  if (!isHomePage && !isFabricsPage && !isIkigaiPage && !isMissionPage && !isAmbassadorsPage && !isAmbassadorRegistrationPage) return;

  const pageName = isHomePage
      ? 'home'
      : isIkigaiPage
      ? 'ikigai'
      : isMissionPage
        ? 'mission'
        : isAmbassadorsPage
          ? 'ambassadors'
          : isAmbassadorRegistrationPage
            ? 'ambassador-registration'
            : 'fabrics';

  const normalizePath = (path) => {
    const clean = String(path || '/').replace(/\/+$/, '') || '/';
    return clean === '/pages/home' ? '/' : clean;
  };

  const moveEcosystemPage = (direction) => {
    if (pageName === 'mission') return false;
    const sequence = ['/', '/pages/ikigai', '/pages/fabrics'];
    const current = normalizePath(window.location.pathname);
    if (current === '/pages/fabrics' && direction > 0) {
      window.location.assign('/');
      return true;
    }
    const currentIndex = sequence.indexOf(current);
    if (currentIndex < 0) return false;
    const next = currentIndex + direction;
    if (next < 0 || next >= sequence.length) return false;
    window.location.assign(sequence[next]);
    return true;
  };

  main.dataset.zodaPageSnapReady = 'true';

  const labels = pageName === 'home'
    ? ['Hero', "What's New", 'Reviews', 'Shop', 'Feature Video', 'Fabric', 'Pillars', 'Technology', 'Mindset', 'Do Things', 'Instagram', 'Contact']
    : pageName === 'fabrics'
      ? ['Overview', 'ZENCOT', 'ZOENIX', 'ZOENIXLITE', 'RPSTRNG', 'AURAFORM', 'NYCURV', 'NYX', 'NYXLITE', 'Footer']
    : pageName === 'ikigai'
      ? ['Hero', 'Ikigai', 'Warriors', 'Technology', 'AuraForm', 'Sustainability', 'Community', 'Footer']
      : pageName === 'ambassadors'
        ? ['Hero', 'Mindset', 'Athletes', 'Join']
      : pageName === 'ambassador-registration'
        ? ['Hero', 'Program', 'Who We Want', 'Perks', 'How to Join', 'Roster', 'Rise']
      : [];

  const getPanelLabel = (panel, index) => {
    const cleanLabel = (value) => String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .slice(0, 36);
    const explicitLabelSource = panel.matches('[data-zoda-nav-label]')
      ? panel
      : panel.querySelector('[data-zoda-nav-label]');
    const explicitLabel = cleanLabel(explicitLabelSource?.getAttribute('data-zoda-nav-label'));
    if (explicitLabel) return explicitLabel;
    if (panel.classList.contains('shopify-section-group-footer-group') || panel.querySelector('.zoda-footer')) return 'Footer';
    if (labels[index]) return labels[index];
    const heading = panel.querySelector('h1, h2, [class*="heading"], [class*="title"]');
    return cleanLabel(heading?.textContent) || `Section ${index + 1}`;
  };

  const positionRegistrationRoster = () => {
    if (pageName !== 'ambassador-registration') return;
    const registration = main.querySelector('[data-zoda-ambassador-registration]');
    const perks = registration?.querySelector('.zoda-ambassador-registration__perks-section');
    const roster = main.querySelector('.zoda-ambassadors__roster[data-zoda-ambassadors-panel]');
    const rosterSection = roster?.closest('[data-zoda-ambassadors]');
    if (!registration || !perks || !rosterSection) return;
    if (rosterSection.parentElement !== registration || rosterSection.nextElementSibling !== perks) {
      perks.before(rosterSection);
    }
  };

  positionRegistrationRoster();

  const collectPanels = () => {
    if (pageName === 'home') {
      return Array.from(main.querySelectorAll(':scope > .shopify-section.shopify-section--zoda-snap-panel'))
        .filter((section) => section.getBoundingClientRect().height > 24);
    }

    if (pageName === 'ambassadors') {
      return Array.from(main.querySelectorAll('[data-zoda-ambassadors-panel]'))
        .filter((section) => section.getBoundingClientRect().height > 24);
    }

    if (pageName === 'ambassador-registration') {
      return Array.from(main.querySelectorAll('[data-zoda-registration-panel], .zoda-ambassadors__roster[data-zoda-ambassadors-panel]'));
    }

    const sections = Array.from(main.querySelectorAll(':scope > .shopify-section'))
      .filter((section) => section.getBoundingClientRect().height > 24);
    const footer = document.querySelector('.shopify-section-group-footer-group');
    if (footer && footer.getBoundingClientRect().height > 24) sections.push(footer);
    return sections;
  };

  let panels = collectPanels();
  if (panels.length < 2) return;

  document.body.dataset.zodaSnapPage = pageName;
  document.documentElement.dataset.zodaPageSnapReady = 'true';
  document.documentElement.dataset.zodaSnapPage = pageName;
  panels.forEach((panel, index) => {
    panel.dataset.snapPanel = String(index);
    panel.dataset.zodaPageSnapPanel = 'true';
  });
  document.body.dataset.zodaSnapEnabled = 'true';

  const navigationEntry = performance.getEntriesByType?.('navigation')?.[0];
  const navigationType = navigationEntry?.type || '';
  const shouldResetInitialScroll = pageName === 'home' &&
    !window.location.hash &&
    navigationType !== 'back_forward';
  if (shouldResetInitialScroll && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  if (shouldResetInitialScroll && Math.round(window.pageYOffset || document.documentElement.scrollTop || 0) > 1) {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  const nav = document.createElement('nav');
  nav.className = 'zoda-page-snap-dots';
  nav.setAttribute('aria-label', `${pageName === 'page' ? 'Page' : pageName} section navigation`);
  const buttons = panels.map((panel, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'zoda-page-snap-dot';
    button.setAttribute('aria-label', getPanelLabel(panel, index));
    button.addEventListener('click', () => scrollToIndex(index));
    nav.appendChild(button);
    return button;
  });
  document.body.appendChild(nav);

  let activeIndex = 0;
  let locked = false;
  let touchStartY = null;
  let touchStartX = null;
  let touchLastY = null;
  let touchLastX = null;
  let touchCaptured = false;
  let touchActionTaken = false;
  let lastTouchStepAt = 0;
  let mobilePinnedPanel = null;
  let mobilePinFrame = 0;
  let mobilePinTimer = 0;
  let mobilePinStartTop = 0;
  let mobilePinTargetTop = 0;
  let mobilePinStartAt = 0;
  let mobilePinAnimationMs = 0;
  let desktopPinnedPanel = null;
  let desktopPinFrame = 0;
  let desktopPinTimer = 0;
  let desktopPinStartTop = 0;
  let desktopPinTargetTop = 0;
  let desktopPinStartAt = 0;
  let desktopPinAnimationMs = 0;
  let wheelDeltaY = 0;
  let wheelDeltaTimer = 0;

  const pageLockMs = 850;
  const internalLockMs = 650;
  const slowDesktopPageLockMs = 1050;
  const slowDesktopInternalLockMs = 760;
  const desktopHomePageAnimationMs = 560;
  const slowDesktopPageAnimationMs = 680;
  const desktopWheelIntentThreshold = 0.75;
  const desktopWheelResetMs = 180;
  const desktopHomeWheelThreshold = 8;
  const slowDesktopWheelThreshold = 14;
  const mobilePageLockMs = 900;
  const mobileInternalLockMs = 700;
  const mobilePageAnimationMs = 460;
  const mobilePinIntentThreshold = 4;
  const mobilePinIntentRatio = 1.12;
  const mobileTouchIntentThreshold = 10;
  const mobileTouchIntentRatio = 1.12;
  const mobileSwipeThreshold = 34;
  const mobileReleaseSwipeThreshold = 28;
  const mobileSwipeDiagonalRatio = 1.28;

  const isMobileViewport = () => window.matchMedia('(max-width: 760px)').matches;
  const isIOS = () => {
    const ua = navigator.userAgent || '';
    const platform = navigator.platform || '';
    return /iPad|iPhone|iPod/.test(ua) ||
      (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  };
  const isAndroid = () => /Android/.test(navigator.userAgent || '');
  const isSlowDesktopSnapPage = () => pageName === 'home' || pageName === 'ikigai' || pageName === 'fabrics' || pageName === 'ambassadors' || pageName === 'ambassador-registration';
  const isStrictMobileSnapPage = () => pageName === 'home' || pageName === 'ikigai' || pageName === 'fabrics' || pageName === 'ambassadors' || pageName === 'ambassador-registration';
  const getPageLockDuration = () => (
    isMobileViewport()
      ? mobilePageLockMs
      : isSlowDesktopSnapPage()
        ? slowDesktopPageLockMs
        : pageLockMs
  );
  const getInternalLockDuration = () => (
    isMobileViewport()
      ? mobileInternalLockMs
      : isSlowDesktopSnapPage()
        ? slowDesktopInternalLockMs
        : internalLockMs
  );
  const getDesktopPageAnimationDuration = () => (
    isSlowDesktopSnapPage() ? slowDesktopPageAnimationMs : desktopHomePageAnimationMs
  );
  const getDesktopWheelThreshold = () => (
    isSlowDesktopSnapPage() ? slowDesktopWheelThreshold : desktopHomeWheelThreshold
  );
  const isSnapSuppressed = (target) => (
    document.body.classList.contains('zoda-mab-signup-open') ||
    Boolean(target?.closest?.('[data-zoda-mab-signup-modal]'))
  );
  const easeOutCubic = (progress) => 1 - Math.pow(1 - progress, 3);

  const syncViewportHeight = () => {
    if (!isMobileViewport()) {
      document.documentElement.style.removeProperty('--zoda-page-snap-vh');
      return;
    }
    const height = Math.round(window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight || 0);
    if (height > 0) document.documentElement.style.setProperty('--zoda-page-snap-vh', `${height}px`);
  };

  const refreshPanels = () => {
    panels = collectPanels();
    panels.forEach((panel, index) => {
      panel.dataset.snapPanel = String(index);
      panel.dataset.zodaPageSnapPanel = 'true';
    });
  };

  const setActive = (index) => {
    activeIndex = Math.max(0, Math.min(index, panels.length - 1));
    document.body.dataset.zodaSnapActivePanel = String(activeIndex + 1);
    buttons.forEach((button, buttonIndex) => {
      const active = buttonIndex === activeIndex;
      button.classList.toggle('is-active', active);
      if (active) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
  };

  const nearestPanelIndex = () => {
    const viewportCenter = window.scrollY + window.innerHeight / 2;
    return panels.reduce((nearest, panel, index) => {
      const nearestPanel = panels[nearest];
      const nearestCenter = nearestPanel.offsetTop + nearestPanel.offsetHeight / 2;
      const panelCenter = panel.offsetTop + panel.offsetHeight / 2;
      return Math.abs(panelCenter - viewportCenter) < Math.abs(nearestCenter - viewportCenter)
        ? index
        : nearest;
    }, 0);
  };

  const isExcludedGatePanel = (panel) => {
    if (!panel) return false;
    return Boolean(panel.querySelector('.zoda-circuit__panel--reviews, .zoda-circuit__reviews-grid, .zoda-pim__rail, .zoda-product-card'));
  };

  const setTemporaryLock = (duration = internalLockMs) => {
    locked = true;
    window.setTimeout(() => {
      locked = false;
      if (!touchActionTaken) touchCaptured = false;
      if (!isMobileViewport() && !desktopPinnedPanel) delete document.documentElement.dataset.zodaSnapControllerScrolling;
    }, duration);
  };

  const preventNativeTouch = (event) => {
    if (event.cancelable !== false) event.preventDefault();
  };

  const getPanelTop = (panel) => (
    panel
      ? Math.round(panel.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0))
      : 0
  );
  const getScrollTop = () => Math.round(window.pageYOffset || document.documentElement.scrollTop || 0);

  const scrollPanelTo = (panel, behavior = 'smooth') => {
    if (!panel) return;
    if (isMobileViewport()) {
      window.scrollTo({ top: getPanelTop(panel), behavior });
      return;
    }
    panel.scrollIntoView({ behavior, block: 'start' });
  };

  const stopMobilePin = (finalPanel = mobilePinnedPanel) => {
    window.clearTimeout(mobilePinTimer);
    mobilePinTimer = 0;
    if (mobilePinFrame) window.cancelAnimationFrame(mobilePinFrame);
    mobilePinFrame = 0;
    mobilePinnedPanel = null;
    mobilePinAnimationMs = 0;
    delete document.documentElement.dataset.zodaSnapTouchLocked;
    delete document.documentElement.dataset.zodaSnapControllerScrolling;
    if (finalPanel && isMobileViewport()) scrollPanelTo(finalPanel, 'auto');
  };

  const enforceMobilePin = () => {
    if (!mobilePinnedPanel || !isMobileViewport()) {
      stopMobilePin(null);
      return;
    }

    let targetTop = mobilePinTargetTop || getPanelTop(mobilePinnedPanel);
    if (mobilePinAnimationMs > 0) {
      const progress = Math.min(1, (performance.now() - mobilePinStartAt) / mobilePinAnimationMs);
      targetTop = Math.round(mobilePinStartTop + ((mobilePinTargetTop - mobilePinStartTop) * easeOutCubic(progress)));
      if (progress >= 1) mobilePinAnimationMs = 0;
    }

    if (Math.abs((window.pageYOffset || document.documentElement.scrollTop || 0) - targetTop) > 1) {
      window.scrollTo({ top: targetTop, behavior: 'auto' });
    }
    mobilePinFrame = window.requestAnimationFrame(enforceMobilePin);
  };

  const startMobilePin = (panel, duration, options = {}) => {
    if (!isMobileViewport() || !panel) return;
    window.clearTimeout(mobilePinTimer);
    if (mobilePinFrame) window.cancelAnimationFrame(mobilePinFrame);
    mobilePinStartTop = Math.round(window.pageYOffset || document.documentElement.scrollTop || 0);
    mobilePinTargetTop = getPanelTop(panel);
    mobilePinStartAt = performance.now();
    mobilePinAnimationMs = options.animate && Math.abs(mobilePinTargetTop - mobilePinStartTop) > 2
      ? Math.min(mobilePageAnimationMs, Math.max(0, duration - 160))
      : 0;
    mobilePinnedPanel = panel;
    document.documentElement.dataset.zodaSnapControllerScrolling = 'true';
    document.documentElement.dataset.zodaSnapTouchLocked = 'true';
    if (!mobilePinAnimationMs) scrollPanelTo(panel, 'auto');
    mobilePinFrame = window.requestAnimationFrame(enforceMobilePin);
    mobilePinTimer = window.setTimeout(() => stopMobilePin(panel), duration);
  };

  const stopDesktopPin = (finalPanel = desktopPinnedPanel) => {
    window.clearTimeout(desktopPinTimer);
    desktopPinTimer = 0;
    if (desktopPinFrame) window.cancelAnimationFrame(desktopPinFrame);
    desktopPinFrame = 0;
    desktopPinnedPanel = null;
    desktopPinAnimationMs = 0;
    delete document.documentElement.dataset.zodaSnapControllerScrolling;
    if (finalPanel && !isMobileViewport()) scrollPanelTo(finalPanel, 'auto');
  };

  const enforceDesktopPin = () => {
    if (!desktopPinnedPanel || isMobileViewport()) {
      stopDesktopPin(null);
      return;
    }

    let targetTop = desktopPinTargetTop || getPanelTop(desktopPinnedPanel);
    if (desktopPinAnimationMs > 0) {
      const progress = Math.min(1, (performance.now() - desktopPinStartAt) / desktopPinAnimationMs);
      targetTop = Math.round(desktopPinStartTop + ((desktopPinTargetTop - desktopPinStartTop) * easeOutCubic(progress)));
      if (progress >= 1) desktopPinAnimationMs = 0;
    }

    if (Math.abs(getScrollTop() - targetTop) > 1) {
      window.scrollTo({ top: targetTop, behavior: 'auto' });
    }
    desktopPinFrame = window.requestAnimationFrame(enforceDesktopPin);
  };

  const startDesktopPin = (panel, duration, options = {}) => {
    if (isMobileViewport() || !panel) return;
    window.clearTimeout(desktopPinTimer);
    if (desktopPinFrame) window.cancelAnimationFrame(desktopPinFrame);
    desktopPinStartTop = getScrollTop();
    desktopPinTargetTop = getPanelTop(panel);
    desktopPinStartAt = performance.now();
    desktopPinAnimationMs = options.animate && Math.abs(desktopPinTargetTop - desktopPinStartTop) > 2
      ? Math.min(getDesktopPageAnimationDuration(), Math.max(0, duration - 220))
      : 0;
    desktopPinnedPanel = panel;
    document.documentElement.dataset.zodaSnapControllerScrolling = 'true';
    if (!desktopPinAnimationMs) scrollPanelTo(panel, 'auto');
    desktopPinFrame = window.requestAnimationFrame(enforceDesktopPin);
    desktopPinTimer = window.setTimeout(() => stopDesktopPin(panel), duration);
  };

  const setIndexedOpenState = (items, nextIndex, options = {}) => {
    const {
      itemOpenClass = 'is-open',
      pastClass = '',
      tabSelector = '',
      activeTabClass = 'is-active',
      contentSelector = '',
      hideInactiveContent = false,
      useDetailsOpen = false
    } = options;

    items.forEach((item, itemIndex) => {
      const isOpen = itemIndex === nextIndex;
      item.classList.toggle(itemOpenClass, isOpen);
      if (pastClass) item.classList.toggle(pastClass, itemIndex < nextIndex);
      if (useDetailsOpen && 'open' in item) item.open = isOpen;
      item.setAttribute('aria-current', isOpen ? 'true' : 'false');

      const tab = tabSelector ? item.querySelector(tabSelector) : null;
      if (tab) {
        tab.classList.toggle(activeTabClass, isOpen);
        tab.setAttribute('aria-expanded', String(isOpen));
        if ('tabIndex' in tab) tab.tabIndex = isOpen ? 0 : -1;
      }

      const content = contentSelector ? item.querySelector(contentSelector) : null;
      if (content) {
        content.setAttribute('aria-hidden', String(!isOpen));
        if (hideInactiveContent) content.toggleAttribute('hidden', !isOpen);
      }
    });
  };

  const getActiveItemIndex = (items, fallback = 0) => {
    const index = items.findIndex((item) => (
      item.classList.contains('is-open') ||
      item.classList.contains('is-active') ||
      item.open === true
    ));
    if (index >= 0) return index;
    const currentIndex = items.findIndex((item) => item.getAttribute('aria-current') === 'true');
    return currentIndex >= 0 ? currentIndex : Math.max(0, Math.min(fallback, items.length - 1));
  };

  const getLinearGate = (panel, gateSelector, itemSelector, options = {}) => {
    const gate = panel.querySelector(gateSelector);
    if (!gate) return null;
    const items = Array.from(gate.querySelectorAll(itemSelector));
    if (items.length < 2) return null;

    const setIndex = (nextIndex) => {
      const index = Math.max(0, Math.min(nextIndex, items.length - 1));
      setIndexedOpenState(items, index, options);
      gate.dataset.zodaGateIndex = String(index);
      if (options.changeEvent) {
        gate.dispatchEvent(new CustomEvent(options.changeEvent, {
          bubbles: true,
          detail: { index }
        }));
      }
      return index;
    };

    return {
      getIndex: () => getActiveItemIndex(items, Number(gate.dataset.zodaGateIndex || 0)),
      getMaxIndex: () => items.length - 1,
      setIndex,
      step(direction) {
        const current = this.getIndex();
        const next = current + direction;
        if (next < 0 || next > this.getMaxIndex()) return false;
        setIndex(next);
        return true;
      }
    };
  };

  const getFabricSystemGate = (panel) => {
    const gate = panel.querySelector('[data-zoda-fabric]');
    if (!gate) return null;
    const viewport = gate.querySelector('[data-zoda-fabric-viewport]');
    const track = gate.querySelector('[data-zoda-fabric-track]');
    const cards = Array.from(gate.querySelectorAll('[data-zoda-fabric-card]'));
    if (!track || cards.length < 2) return null;

    const getVisibleCards = () => {
      if (!viewport || !cards.length) return 1;
      const style = window.getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      const cardWidth = cards[0].getBoundingClientRect().width || 1;
      const viewportWidth = viewport.clientWidth || cardWidth;
      return Math.max(1, Math.min(cards.length, Math.floor((viewportWidth + gap + 2) / (cardWidth + gap))));
    };

    const getMaxIndex = () => Math.max(0, cards.length - getVisibleCards());

    const setIndex = (nextIndex) => {
      const maxIndex = getMaxIndex();
      const index = Math.max(0, Math.min(nextIndex, maxIndex));
      const targetLeft = cards[index]?.offsetLeft || 0;
      const progress = gate.querySelector('[data-zoda-fabric-progress]');
      const count = gate.querySelector('[data-zoda-fabric-count]');

      if (viewport && isMobileViewport()) {
        track.style.transform = 'none';
        viewport.scrollTo?.({ left: targetLeft, behavior: 'smooth' });
      } else {
        track.style.transform = `translate3d(${-targetLeft}px, 0, 0)`;
      }

      cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === index));
      if (progress) progress.style.transform = `scaleX(${Math.min(cards.length, index + getVisibleCards()) / cards.length})`;
      if (count) {
        const shown = Math.min(cards.length, index + getVisibleCards());
        count.textContent = `${String(shown).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      }

      gate.dataset.zodaGateIndex = String(index);
      return index;
    };

    return {
      getIndex: () => {
        const active = cards.findIndex((card) => card.classList.contains('is-active'));
        return Math.max(0, active >= 0 ? active : Number(gate.dataset.zodaGateIndex || 0));
      },
      getMaxIndex,
      setIndex,
      step(direction) {
        const next = this.getIndex() + direction;
        if (next < 0 || next > this.getMaxIndex()) return false;
        setIndex(next);
        return true;
      }
    };
  };

  const getIkigaiIntroGate = (panel) => {
    if (!isMobileViewport()) return null;
    const gate = panel.querySelector('.zoda-ikigai-purpose__cards');
    if (!gate) return null;
    const cards = Array.from(gate.querySelectorAll('.zoda-ikigai-purpose__card'));
    if (cards.length < 2) return null;

    const setIndex = (nextIndex) => {
      const index = Math.max(0, Math.min(nextIndex, cards.length - 1));
      gate.scrollTo?.({ left: cards[index].offsetLeft, behavior: 'smooth' });
      cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === index));
      gate.dataset.zodaGateIndex = String(index);
      return index;
    };

    return {
      getIndex: () => Math.max(0, Math.min(Number(gate.dataset.zodaGateIndex || 0), cards.length - 1)),
      getMaxIndex: () => cards.length - 1,
      setIndex,
      step(direction) {
        const next = this.getIndex() + direction;
        if (next < 0 || next > this.getMaxIndex()) return false;
        setIndex(next);
        return true;
      }
    };
  };

  const getPanelGate = (panel) => {
    if (!panel || isExcludedGatePanel(panel)) return null;

    // Internal accordions, carousels, and tabs now stay independent from page snap.
    return null;
  };

  const primePanelGate = (panel, direction = 1) => {
    const gate = getPanelGate(panel);
    if (!gate) return;
    gate.setIndex(direction < 0 ? gate.getMaxIndex() : 0);
  };

  const scrollToIndex = (index) => {
    refreshPanels();
    const next = Math.max(0, Math.min(index, panels.length - 1));
    const panel = panels[next];
    if (!panel) return;
    const duration = getPageLockDuration();
    locked = true;
    setActive(next);
    primePanelGate(panel, 1);
    if (isMobileViewport()) startMobilePin(panel, duration, { animate: true });
    else startDesktopPin(panel, duration, { animate: true });
    window.setTimeout(() => {
      locked = false;
      setActive(nearestPanelIndex());
      if (!touchActionTaken) touchCaptured = false;
      if (!isMobileViewport() && !desktopPinnedPanel) delete document.documentElement.dataset.zodaSnapControllerScrolling;
    }, duration);
  };

  const isInsideInternalScroller = (target, deltaY) => {
    if (!(target instanceof Element)) return false;
    let el = target;
    while (el && el !== document.body && el !== document.documentElement) {
      const style = window.getComputedStyle(el);
      const overflowY = style.overflowY;
      const node = el;
      if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
        const atTop = node.scrollTop <= 0;
        const atBottom = node.scrollTop + node.clientHeight >= node.scrollHeight - 1;
        if (deltaY < 0 && !atTop) return true;
        if (deltaY > 0 && !atBottom) return true;
      }
      el = el.parentElement;
    }
    return false;
  };

  const step = (direction) => {
    if (locked) return false;
    const current = nearestPanelIndex();
    const currentPanel = panels[current];
    const gate = getPanelGate(currentPanel);
    if (gate && gate.step(direction)) {
      const duration = getInternalLockDuration();
      setActive(current);
      if (isMobileViewport()) startMobilePin(currentPanel, duration);
      else startDesktopPin(currentPanel, duration);
      setTemporaryLock(duration);
      return true;
    }

    const next = current + direction;
    if (next < 0 || next >= panels.length) {
      return moveEcosystemPage(direction);
    }
    const nextPanel = panels[next];
    const duration = getPageLockDuration();
    locked = true;
    setActive(next);
    primePanelGate(nextPanel, direction);
    if (isMobileViewport()) startMobilePin(nextPanel, duration, { animate: true });
    else startDesktopPin(nextPanel, duration, { animate: true });
    window.setTimeout(() => {
      locked = false;
      setActive(nearestPanelIndex());
      if (!touchActionTaken) touchCaptured = false;
      if (!isMobileViewport() && !desktopPinnedPanel) delete document.documentElement.dataset.zodaSnapControllerScrolling;
    }, duration);
    return true;
  };

  const onWheel = (event) => {
    if (isSnapSuppressed(event.target) || event.defaultPrevented || event.ctrlKey) return;
    const mobile = isMobileViewport();
    const absY = Math.abs(event.deltaY);
    const absX = Math.abs(event.deltaX);
    if (!mobile && (absY <= 0 || absX > absY)) return;
    if (mobile && (absY < 8 || absX > absY)) return;
    if (isInsideInternalScroller(event.target, event.deltaY)) return;
    event.preventDefault();
    if (locked) return;
    if (!mobile && absY < desktopWheelIntentThreshold) return;

    if (mobile) {
      step(event.deltaY > 0 ? 1 : -1);
      return;
    }

    wheelDeltaY += event.deltaY;
    window.clearTimeout(wheelDeltaTimer);
    wheelDeltaTimer = window.setTimeout(() => {
      wheelDeltaY = 0;
      wheelDeltaTimer = 0;
    }, desktopWheelResetMs);

    if (Math.abs(wheelDeltaY) < getDesktopWheelThreshold()) return;
    const direction = wheelDeltaY > 0 ? 1 : -1;
    wheelDeltaY = 0;
    window.clearTimeout(wheelDeltaTimer);
    wheelDeltaTimer = 0;
    step(direction);
  };

  const onKeydown = (event) => {
    const target = event.target;
    if (isSnapSuppressed(target)) return;
    if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)) return;
    if (event.key === 'ArrowDown' || event.key === 'PageDown' || event.key === ' ') {
      event.preventDefault();
      step(1);
    } else if (event.key === 'ArrowUp' || event.key === 'PageUp') {
      event.preventDefault();
      step(-1);
    } else if (event.key === 'Home') {
      event.preventDefault();
      scrollToIndex(0);
    } else if (event.key === 'End') {
      event.preventDefault();
      scrollToIndex(panels.length - 1);
    }
  };

  const onTouchStart = (event) => {
    if (isSnapSuppressed(event.target)) {
      touchStartY = null;
      touchStartX = null;
      return;
    }
    if (!event.touches.length) return;
    const touch = event.touches[0];
    touchStartY = touch.clientY;
    touchStartX = touch.clientX;
    touchLastY = touch.clientY;
    touchLastX = touch.clientX;
    touchCaptured = false;
    touchActionTaken = false;
  };

  const onTouchMove = (event) => {
    if (isSnapSuppressed(event.target)) return;
    if ((isMobileViewport() && event.defaultPrevented) || touchStartY === null || touchStartX === null) return;
    if (locked) {
      if (isMobileViewport()) preventNativeTouch(event);
      return;
    }
    if (touchActionTaken) {
      if (isMobileViewport()) preventNativeTouch(event);
      return;
    }
    const touch = event.touches[0];
    touchLastY = touch.clientY;
    touchLastX = touch.clientX;
    const deltaY = touchStartY - touch.clientY;
    const deltaX = touchStartX - touch.clientX;
    const mobile = isMobileViewport();
    const threshold = mobile ? mobileSwipeThreshold : 42;
    const diagonalRatio = mobile ? mobileSwipeDiagonalRatio : 1;
    const absY = Math.abs(deltaY);
    const absX = Math.abs(deltaX);
    const now = Date.now();
    const insideInternalScroller = isInsideInternalScroller(event.target, deltaY);
    const strictMobileSnap = mobile && isStrictMobileSnapPage();
    const intentThreshold = strictMobileSnap ? mobilePinIntentThreshold : mobileTouchIntentThreshold;
    const intentRatio = strictMobileSnap ? mobilePinIntentRatio : mobileTouchIntentRatio;
    if (
      mobile &&
      !insideInternalScroller &&
      absY >= intentThreshold &&
      absY >= absX * intentRatio
    ) {
      preventNativeTouch(event);
      touchCaptured = true;
      if (strictMobileSnap && !mobilePinnedPanel) {
        startMobilePin(panels[nearestPanelIndex()], getInternalLockDuration());
      }
    }
    if (absY < threshold || absY < absX * diagonalRatio) return;
    if (mobile && now - lastTouchStepAt < getInternalLockDuration()) {
      preventNativeTouch(event);
      return;
    }
    if (insideInternalScroller) return;
    preventNativeTouch(event);
    touchCaptured = mobile && (isIOS() || isAndroid());
    touchActionTaken = mobile;
    lastTouchStepAt = now;
    step(deltaY > 0 ? 1 : -1);
    touchStartY = touch.clientY;
    touchStartX = touch.clientX;
    touchLastY = touch.clientY;
    touchLastX = touch.clientX;
  };

  const resetTouchState = () => {
    touchStartY = null;
    touchStartX = null;
    touchLastY = null;
    touchLastX = null;
    touchCaptured = false;
    touchActionTaken = false;
  };

  const onTouchEnd = (event) => {
    if (
      isMobileViewport() &&
      touchCaptured &&
      !touchActionTaken &&
      !locked &&
      touchStartY !== null &&
      touchStartX !== null
    ) {
      const touch = event.changedTouches?.[0];
      const endY = touch?.clientY ?? touchLastY;
      const endX = touch?.clientX ?? touchLastX;
      const deltaY = touchStartY - endY;
      const deltaX = touchStartX - endX;
      const absY = Math.abs(deltaY);
      const absX = Math.abs(deltaX);
      const now = Date.now();

      if (
        absY >= mobileReleaseSwipeThreshold &&
        absY >= absX * mobileSwipeDiagonalRatio &&
        now - lastTouchStepAt >= getInternalLockDuration() &&
        !isInsideInternalScroller(event.target, deltaY)
      ) {
        preventNativeTouch(event);
        touchActionTaken = true;
        lastTouchStepAt = now;
        step(deltaY > 0 ? 1 : -1);
      }
    }

    resetTouchState();
  };

  const observer = new IntersectionObserver((entries) => {
    const visible = entries
      .filter((entry) => entry.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
    if (!visible) return;
    const index = panels.indexOf(visible.target);
    if (index >= 0) setActive(index);
  }, { threshold: [0.45, 0.6, 0.75] });

  panels.forEach((panel) => observer.observe(panel));
  syncViewportHeight();
  window.addEventListener('wheel', onWheel, { passive: false });
  window.addEventListener('keydown', onKeydown);
  window.addEventListener('touchstart', onTouchStart, { capture: true, passive: true });
  window.addEventListener('touchmove', onTouchMove, { capture: true, passive: false });
  window.addEventListener('touchend', onTouchEnd, { capture: true, passive: false });
  window.addEventListener('touchcancel', resetTouchState, { capture: true, passive: true });
  window.addEventListener('resize', () => {
    syncViewportHeight();
    refreshPanels();
    setActive(nearestPanelIndex());
  }, { passive: true });
  window.visualViewport?.addEventListener('resize', syncViewportHeight, { passive: true });

  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);
    const targetPanel = target?.closest('[data-zoda-page-snap-panel="true"]');
    const targetIndex = targetPanel ? panels.indexOf(targetPanel) : -1;
    if (targetIndex >= 0) window.setTimeout(() => scrollToIndex(targetIndex), 120);
  } else if (shouldResetInitialScroll) {
    setActive(0);
    window.setTimeout(() => scrollToIndex(0), 80);
  } else {
    setActive(nearestPanelIndex());
  }
})();
